import { Link } from "wouter";
import { APP_TITLE } from "@/const";
import { Mail, Phone, MapPin, Linkedin } from "lucide-react";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-primary text-primary-foreground">
      <div className="container py-12 lg:py-16">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-4">
          {/* Company Info */}
          <div className="space-y-4">
            <h3 className="text-lg font-bold">{APP_TITLE}</h3>
            <p className="text-sm text-primary-foreground/80">
              Acquiring and growing exceptional trucking and logistics companies through disciplined governance and strategic direction.
            </p>
          </div>

          {/* Quick Links */}
          <div className="space-y-4">
            <h4 className="text-sm font-semibold uppercase tracking-wider">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <Link href="/">
                  <a className="text-sm text-primary-foreground/80 hover:text-primary-foreground transition-colors">
                    Home
                  </a>
                </Link>
              </li>
              <li>
                <Link href="/about">
                  <a 
                    className="text-sm text-primary-foreground/80 hover:text-primary-foreground transition-colors"
                    aria-label="About Stanford Logistics Management"
                  >
                    About
                  </a>
                </Link>
              </li>
              <li>
                <Link href="/blog">
                  <a className="text-sm text-primary-foreground/80 hover:text-primary-foreground transition-colors">
                    Insights
                  </a>
                </Link>
              </li>
              <li>
                <Link href="/contact">
                  <a className="text-sm text-primary-foreground/80 hover:text-primary-foreground transition-colors">
                    Contact
                  </a>
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Information */}
          <div className="space-y-4">
            <h4 className="text-sm font-semibold uppercase tracking-wider">Contact</h4>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <Mail size={18} className="mt-0.5 flex-shrink-0" />
                <a
                  href="mailto:info@stanfordlogistics.net"
                  className="text-sm text-primary-foreground/80 hover:text-primary-foreground transition-colors"
                >
                  info@stanfordlogistics.net
                </a>
              </li>
              <li className="flex items-start space-x-3">
                <Phone size={18} className="mt-0.5 flex-shrink-0" />
                <a
                  href="tel:+12014703182"
                  className="text-sm text-primary-foreground/80 hover:text-primary-foreground transition-colors"
                >
                  201-470-3182
                </a>
              </li>
              <li className="flex items-start space-x-3">
                <MapPin size={18} className="mt-0.5 flex-shrink-0" />
                <span className="text-sm text-primary-foreground/80">
                  Savannah, GA
                </span>
              </li>
            </ul>
          </div>

          {/* Legal Links */}
          <div className="space-y-4">
            <h4 className="text-sm font-semibold uppercase tracking-wider">Legal</h4>
            <ul className="space-y-2">
              <li>
                <Link href="/privacy">
                  <a className="text-sm text-primary-foreground/80 hover:text-primary-foreground transition-colors">
                    Privacy Policy
                  </a>
                </Link>
              </li>
              <li>
                <Link href="/terms">
                  <a className="text-sm text-primary-foreground/80 hover:text-primary-foreground transition-colors">
                    Terms of Service
                  </a>
                </Link>
              </li>
            </ul>
            <div className="pt-2">
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center space-x-2 text-sm text-primary-foreground/80 hover:text-primary-foreground transition-colors"
                aria-label="LinkedIn"
              >
                <Linkedin size={20} />
                <span>Follow us</span>
              </a>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-primary-foreground/20">
          <p className="text-center text-sm text-primary-foreground/60">
            © {currentYear} {APP_TITLE}. All rights reserved. • Site built by{" "}
            <a
              href="https://mosheli.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-primary-foreground/80 hover:text-primary-foreground transition-colors underline"
            >
              Mosheli
            </a>
            .
          </p>
        </div>
      </div>
    </footer>
  );
}
